import { useMutation } from "@tanstack/react-query";

import { postCustomer } from "../api/customer";

const usePostCustomer = () => {
  const mutation = useMutation({
    mutationFn: postCustomer,
  });
  return mutation;
};

export default usePostCustomer;
